import "../header/header.css";
import BannerPirate from "../../assets/img/appreciation-night/header-banner.jpg";
import AppLogo from "../../assets/img/appreciation-night/logo.png";
import Invite from "../../assets/img/appreciation-night/invite.png";
// import BannerFestival from "../../assets/img/APRE/logo-niec.bcfd59b8b3c7664dc1f6.png";
import { useLocation } from "react-router-dom";
import introVideo from "../../assets/video/ship-wave.webm";

const Navbar = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("to");
  const capitalizeWords = (text) => {
    if (!text) return "";
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  return (
    <section className="header" id="header">
      <div className="position-relative">
        <img className="appreciation-logo img-fluid" src={AppLogo} alt="logo" />
        <video
          src={introVideo}
          autoPlay
          muted
          playsInline
          className="video-gradient"
        />
        <div className="subtitle">
          <span className="line"></span>
          <p className="text">Sailing Towards Honor</p>
          <span className="line"></span>
        </div>
        <p className="display-date">
          27 Juni 2026 · Makassar
        </p>
        {/* <div className="text-center guest">
          <h5 className="mb-2">Kepada Yth. Bapak/Ibu/Saudara/i :</h5>
          <h5 className="">{id ? capitalizeWords(id) : ""}</h5>
          <hr className="mx-auto border-dark border-2" />
        </div>
        <div>
          <img className="invite" src={Invite} alt="invite" />
        </div> */}
      </div>
    </section>
  );
};

export default Navbar;
